import { APP } from 'src/Configs/App'
import { rtkApi } from 'src/Services/rtkApi'

export interface FavoriteCurator {
  curatorUserId: number
}

export const favoriteCuratorsApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    getFavoriteCurators: builder.query<FavoriteCurator[], void>({
      query: () => `${APP.TIKTOK_SERVER}/artist/favorite-curators`,
      providesTags: ['FavoriteCurators'],
    }),

    addFavoriteCurator: builder.mutation<void, number>({
      query: (curatorUserId) => ({
        url: `${APP.TIKTOK_SERVER}/artist/favorite-curators`,
        method: 'PUT',
        body: {
          curatorUserId,
        },
      }),
      invalidatesTags: ['FavoriteCurators'],
    }),
  }),
})

export const { useGetFavoriteCuratorsQuery, useAddFavoriteCuratorMutation } =
  favoriteCuratorsApi
